import routes from './routes';

export * from './api/index';
export * from './Components/index';

export default routes;
